import React from "react"
import SavedRecipesComponent from "../components/SavedRecipesComponent"

const Saved = () => {
  return <SavedRecipesComponent />
}
export default Saved
